import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'development-summary-review.title',
		defaultMessage: '{boldStart}{count}{boldEnd} {count, plural, one {review} other {reviews}}',
		description: 'The number of reviews associated with a Jira Issue. ',
	},
});
